import React from 'react';
import { Routes, Route } from 'react-router-dom';
import IsraelSchedulePage from './pages/IsraelSchedulePage';
import IsraelLandingPage from './pages/IsraelLandingPage';

// Israel-clinic patient-facing app: only public (no-auth) flows. Rendered on
// the Israel patient domain (see config/appMode.ts). Hebrew / RTL. Does NOT
// reuse the UK SchedulingFlow — it has its own look and behaviour.
function IsraelApp() {
  return (
    <Routes>
      <Route path="/schedule/:token" element={<IsraelSchedulePage />} />
      {/* Unknown/root URL → neutral landing, never the therapist login */}
      <Route path="*" element={<IsraelLandingPage />} />
    </Routes>
  );
}

export default IsraelApp;
